export { default } from 'common/components/MarkdownText'
